module.exports = __webpack_public_path__ + "img/swiper_4.725978e9.png";